export interface TerminalWebSocketConnectionOptions {
  sessionId: string;
  ticket: string;
  protocol: string;
  host: string;
}

export interface TerminalWebSocketConnection {
  url: string;
  protocols: string[];
}

export interface TerminalAccessTicketRequest {
  sessionId: string;
  token: string;
  userId: string;
}

export async function requestTerminalAccessTicket(
  options: TerminalAccessTicketRequest,
): Promise<string> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (options.token) headers.Authorization = `Bearer ${options.token}`;
  if (options.userId) headers['X-Boclaw-User-Id'] = options.userId;
  const response = await fetch(
    `/api/cowork/sessions/${encodeURIComponent(options.sessionId)}/terminal-ticket`,
    { method: 'POST', headers },
  );
  if (!response.ok) throw new Error(`terminal ticket request failed: ${response.status}`);
  const payload = await response.json() as { ticket?: unknown; expiresInMs?: unknown };
  if (typeof payload.ticket !== 'string' || !payload.ticket.startsWith('sat_')) {
    throw new Error('terminal ticket response is invalid');
  }
  if (typeof payload.expiresInMs !== 'number' || payload.expiresInMs <= 0) {
    throw new Error('terminal ticket expiry is invalid');
  }
  return payload.ticket;
}

export function buildTerminalWebSocketConnection(
  options: TerminalWebSocketConnectionOptions,
): TerminalWebSocketConnection {
  const wsProtocol = options.protocol === 'https:' ? 'wss:' : 'ws:';
  const url = `${wsProtocol}//${options.host}/api/cowork/sessions/${encodeURIComponent(options.sessionId)}/terminal-ws`;
  const protocols = ['boclaw-terminal'];
  if (options.ticket) protocols.push(`boclaw-terminal-ticket.${options.ticket}`);
  return { url, protocols };
}
